import * as Yup from 'yup'

import { DeclarationFunction } from '../../../graphql/generated/graphql'
import { actions } from '../../../redux'
import { Icons } from '../../../components/Icon'
import { StepProps } from '../../../types'

type CciFunctionStepProps = StepProps & {
  declarationFunctions: DeclarationFunction[]
}

export const useCciFunctionStep = (props: CciFunctionStepProps): any => {
  const { t, dispatch, declarationFunctions, formValues } = props

  return {
    stepPart: {
      text: t('declaration.form.stepPart.myDeclaration'),
    },
    label: t('declaration.form.cciFunction.label'),
    form: {
      initialValues: {
        cciFunction: formValues.cciFunction,
      },
      validationSchema: Yup.object().shape({
        cciFunction: Yup.string().required(),
      }),
      onSubmit: (values: { cciFunction: string }) => {
        dispatch(
          actions.declaration.setFormValues({
            name: 'cciFunction',
            value: values.cciFunction,
          })
        )
        const selectedFunction = declarationFunctions.find(
          (declarationFunction) => declarationFunction.id === values.cciFunction
        )
        if (selectedFunction?.canDeclareNothing) {
          dispatch(actions.declaration.setNextStep())
        } else {
          dispatch(actions.declaration.setStep(3))
        }
      },
      validateOnChange: false,
    },
    fields: [
      {
        field: {
          name: 'cciFunction',
          required: true,
          allowMultiple: false,
          options: declarationFunctions.map((declarationFunction) => ({
            value: declarationFunction.id,
            label: declarationFunction.name,
            helpText: declarationFunction.description,
          })),
        },
        type: 'toggle',
      },
    ],
    button: {
      text: t('declaration.form.cciFunction.submit.label'),
      disabled: false,
      iconProps: {
        icon: Icons.arrowRight,
      },
      iconPosition: 'right',
    },
  }
}
